import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from '././pages/Login/Login';
import Dashboard from '././pages/Landing/Landing';
import CustomersList from '././pages/CostumersList/CustomersList';
import FiltersList from './pages/FiltersList/FiltersList';
import CustomersFilters from './pages/CustomersFilters/CustomersFilters';
import UsersList from './pages/UsersList/UsersList';
import Layout from './components/Layout/Layout'
import Profile from './pages/Profile/Profile'
import ForgotPassword from './pages/Login/ForgotPassword';
import ResetPassword from './pages/Login/ResetPassword';

const App = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem('authToken');
        setIsAuthenticated(!!token); 
    }, []);

    // Handle login state
    const handleLogin = () => setIsAuthenticated(true);

    return (
        <Routes>
          <Route path="/" element={<Navigate to="/login" />} />
          
          <Route path="/login" element={<Login onLogin={handleLogin} />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          
          <Route
            path="/"
            element={isAuthenticated ? <Layout /> : <Navigate to="/login" />}
          >
            <Route path="customers" element={<CustomersList />} />
            <Route path="customers-filters" element={<CustomersFilters />} />
            <Route path="filters" element={<FiltersList />} />
            <Route path="users" element={<UsersList />} />
            <Route path="landing" element={<Dashboard />} />
            <Route path="profile" element={<Profile />} />
          </Route>
        </Routes>
      );
};

export default App;
